import { TicketingNotificationFilterTypes, notificationFilterTypeToString } from "@avenueops/frontend-shared";
import { Checkbox, TipTapEditor, TextInput } from "@avenueops/web-components";
import Expandable from "components/generic-building-blocks/Expandable";
import { CustomSubscriberTabType } from "components/monitors/editFormReboot/CustomNotificationsAndSignals";
import CustomSubscribersTabTypeHeader from "components/monitors/editFormReboot/CustomSubscribersTabTypeHeader";
import { isSupportedFilter } from "components/monitors/editFormReboot/SubscriberNotificationFilters";
import { useState } from "react";

interface Props {
  recipient: any;
  showNotifications?: boolean;
  showFormatting?: boolean;
}

export function CustomSubscriberSignalFormatView({ recipient, showNotifications, showFormatting }: Props) {
  const [subscriberTabType, setSubscriberTabType] = useState(showFormatting ? CustomSubscriberTabType.FORMATTING : CustomSubscriberTabType.NOTIFICATIONS);
  const supportedTypes = TicketingNotificationFilterTypes;
  return showFormatting && !showNotifications && !recipient.titleFormat && !recipient.messageFormat ? null : (
    <Expandable
      title={<span className="font-semibold text-sm">Customize Signal Formatting</span>}
      tooltipText={`Overwrite the signal title and body only for ${recipient.notificationType} notifications`}
      defaultExpanded={true}
    >
      {showFormatting && showNotifications ? (
        <div className="pb-5">
          <CustomSubscribersTabTypeHeader tabType={subscriberTabType} setTabType={setSubscriberTabType} />
        </div>
      ) : null}
      <div className="data-[tabFormattingOpen=true]:flex hidden w-full" data-tabFormattingOpen={subscriberTabType === CustomSubscriberTabType.FORMATTING}>
        {recipient.titleFormat || recipient.messageFormat ? (
          <div className="w-full flex flex-col">
            <TextInput name="title" defaultValue={recipient.titleFormat} disabled />
            <div className="min-h-[100px] flex">
              <TipTapEditor backgroundColor="bg-gray-200" name="message" initialValue={recipient.messageFormat} readOnly />
            </div>
          </div>
        ) : (
          <div className="text-xs text-gray-600">No customized options for this recipient</div>
        )}
      </div>
      <div
        className="flex flex-col gap-2 data-[tabFormattingOpen=true]:hidden"
        data-tabFormattingOpen={subscriberTabType === CustomSubscriberTabType.FORMATTING}
      >
        {supportedTypes
          .filter((filterType) => isSupportedFilter(filterType, recipient.manualType))
          .map((filterType) => (
            <Checkbox
              key={filterType}
              name={`${filterType}`}
              label={notificationFilterTypeToString(filterType)}
              disabled
              value={new Set(recipient.notificationFilters).has(filterType)}
            />
          ))}
      </div>
    </Expandable>
  );
}
